export const HIGHLIGHTED_SEATS_Z_INDEX = 1;